import styled from 'styled-components';
import { Box } from 'atoms/Box';

export const Flex = styled(Box)`
	display: flex;
`;
